import { ContentCard } from 'ypf-pas-general-ui-components';
import { BsChatRightText } from 'react-icons/bs';
import './NoMessage.scss';

const NoMessage = () => (
  <div className="nomesagge-container">
    <ContentCard className="icon-container" orientation="horizontal">
      <BsChatRightText />
    </ContentCard>
    <p>
      <strong>No disponés de ningún mensaje</strong>
    </p>
    <p>Podes utilizar este espacio para comunicarte.</p>
  </div>
);

export default NoMessage;
